import {
  Breakpoint,
  CollapsibleBar,
  CollapsibleBarVariant,
  Color,
  Drawer,
  EventTile,
  Icon,
  IconName,
  Typography,
  TypographyVariant,
} from '@elearning-platform/ui';
import { useMediaQuery } from '@mui/material';
import React from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import {
  CloseButton,
  CloseButtonContainer,
  Container,
  ContentContainer,
  ContentWrapper,
  Header,
  TileContainer,
} from './eventFormDrawer.styled';
import { EventFormDrawerProps } from './eventFormDrawer.types';
import { Form } from './form/form.component';

export const EventFormDrawer: React.FC<EventFormDrawerProps> = (props: EventFormDrawerProps): JSX.Element => {
  const { onClose, isOpen, formSettings, eventData }: EventFormDrawerProps = props;
  const { t }: TransProps<never> = useTranslation();
  const isSmallDesktop: boolean = useMediaQuery(Breakpoint.SmallDesktop);

  return (
    <Drawer onClose={onClose} open={isOpen}>
      <Container>
        {!!isSmallDesktop && (
          <CollapsibleBar icon={IconName.ChevronRightDouble} onClick={onClose} variant={CollapsibleBarVariant.Popup} />
        )}
        <ContentWrapper>
          <ContentContainer>
            <CloseButtonContainer>
              <CloseButton onClick={onClose}>
                <Icon color={Color.Gray800} name={IconName.Clear} />
              </CloseButton>
            </CloseButtonContainer>
            <TileContainer>
              <Typography variant={TypographyVariant.DisplaySM}>
                <Header text={t('competence.app.eventFormDrawer.form')} />
              </Typography>
              {!!eventData && (
                <EventTile data={eventData} />
              )}
            </TileContainer>
            <Form {...formSettings} onClose={onClose} />
          </ContentContainer>
        </ContentWrapper>
      </Container>
    </Drawer>
  );
};
